import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Container,
  Form,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Spinner,
} from "reactstrap";
import avatar from "../assets/imgs/new/avatar.png";
import { useDropzone } from "react-dropzone";
import { useDispatch, useSelector } from "react-redux";
import {
  createFutureMessage,
  deleteFutureMessage,
  getFutureMessages,
  deleteSingleMediaFile,
  updateFutureMessage,
} from "../redux/actions/futuremessage.action";
import moment from "moment";
import PhoneInput from "react-phone-input-2";
import MainHeader from "../components/MainHeader";
import { customAlert } from "../redux/actions/alertActions";
import "react-phone-input-2/lib/style.css";

function FutureMessages() {
  // Dispatch, Selector
  const dispatch = useDispatch();
  const { loading, future_messages } = useSelector(
    (state) => state.future_message
  );
  const authUser = useSelector((state) => state.authUser);

  // States
  const [modals, setModals] = useState({
    addFuture: false,
  });
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
  const [sendTo, setSendTo] = useState("");
  const [email, setEmail] = useState("");
  const [sms, setSMS] = useState("");
  const [deliveryDate, setDeliveryDate] = useState("");
  const [deliveryTime, setDeliveryTime] = useState("");
  const [files, setFiles] = useState([]);
  const clearFields = () => {
    setTitle("");
    setMessage("");
    setSendTo("");
    setEmail("");
    setSMS("");
    setDeliveryDate("");
    setDeliveryTime("");
    setFiles([]);
  };
  // Functions
  const toggleModal = (name) => {
    let newModal = JSON.parse(JSON.stringify(modals));
    for (let modal of Object.keys(newModal)) {
      if (modal != name) newModal[modal] = false;
    }
    newModal[name] = !newModal[name];
    setModals(newModal);
  };

  const { getRootProps, getInputProps, acceptedFiles } = useDropzone({
    accept: "image/*",
    onDrop: (acceptedFiles) => {
      let tempFiles = acceptedFiles.map((file) =>
        Object.assign(file, {
          preview: URL.createObjectURL(file),
        })
      );
      let tempArr = files.concat(tempFiles);
      setFiles(tempArr);
      // setFiles(
      // acceptedFiles.map(file =>
      // [
      // 	Object.assign(acceptedFiles[0], {
      // 		preview: URL.createObjectURL(acceptedFiles[0]),
      // 	}),
      // ]
      // )
      // );
    },
  });
  let images = files.map((file, index) => (
    <Row key={file.name}>
      <Col xs="4">
        <div style={{ position: "relative" }}>
          <i
            className="fas fa-minus-circle"
            style={{
              color: "red",
              position: "absolute",
              top: "0%",
              right: "0%",
              cursor: "pointer",
            }}
            onClick={() => {
              files.splice(index, 1);
              setFiles([...files]);
            }}
          ></i>
          {file.type.split("/")[0] == "image" ? (
            <img
              src={file.preview}
              style={{ width: "100px", height: "100px" }}
              alt="preview"
              className="mx-2 mt-2"
            ></img>
          ) : (
            <video
              src={file.preview}
              style={{ width: "100px", height: "100px" }}
              alt="preview"
              className="mx-2 mt-2"
            ></video>
          )}
          {/* <i onClick={remove(file)} style={{position:"absolute",top:"0%",left:"70%",cursor:"pointer"}} className='fas fa-times-circle' /> */}
        </div>
      </Col>
    </Row>
  ));
  useEffect(() => {
    if (future_messages.length == 0) {
      dispatch(getFutureMessages(authUser.id));
    }
  }, []);

  // return
  return (
    <>
      <div className="container-fluid pt-3">
        <MainHeader heading={"Future Messages"} />
        <hr />
        <div className="mt-5">
          <h4 className="font-weight-bold">
            {future_messages.length} Future messages
          </h4>

          <Row className="mt-5 mb-2">
            {future_messages.length > 0 &&
              future_messages.map((future, index) => (
                <Col md="6" lg="4" xl="3" key={index} className="mt-3">
                  <Message
                    future={future}
                    dispatch={dispatch}
                    authUser={authUser}
                    loading={loading}
                  />
                </Col>
              ))}
          </Row>

          <Button
            onClick={(e) => toggleModal("addFuture")}
            className="mt-4 btn-outline dashboard-btn"
          >
            + Add Future message
          </Button>
        </div>
      </div>

      <Modal
        isOpen={modals.addFuture}
        size="lg"
        centered
        className="custom-modal"
        // toggle={(e) => {
        //   toggleModal("addFuture");
        //   clearFields();
        // }}
      >
        <ModalBody>
          <div className="modal-content-wrapper ">
            <Form
              onSubmit={(e) => {
                e.preventDefault();
                let obj = {
                  title: title,
                  message: message,
                  send_to: sendTo,
                  email: email,
                  sms: "+" + sms,
                  deliveryDate: deliveryDate,
                  deliveryTime: deliveryTime,
                  media: files,
                  sender_id: authUser.id,
                };
                if (!title) {
                  dispatch(customAlert(true, "Please enter title"));
                  setTimeout(() => {
                    dispatch(customAlert(false, ""));
                  }, 1500);
                  // toast.warning('Please enter title');
                } else if (files.length < 0 && !message) {
                  dispatch(
                    customAlert(
                      true,
                      "Please Select Media or Enter some Message"
                    )
                  );
                  setTimeout(() => {
                    dispatch(customAlert(false, ""));
                  }, 1500);
                  // toast.warning('Please Select Media');
                } else if (!sendTo) {
                  dispatch(customAlert(true, "Please Write reciever name"));
                  setTimeout(() => {
                    dispatch(customAlert(false, ""));
                  }, 1500);
                  // toast.warning('Please Write reciever name');
                } else if (!email && !sms) {
                  dispatch(
                    customAlert(
                      true,
                      "Please Write reciever email or phone number"
                    )
                  );
                  setTimeout(() => {
                    dispatch(customAlert(false, ""));
                  }, 1500);
                } else if (!deliveryDate) {
                  dispatch(customAlert(true, "Please enter delivery date"));
                  setTimeout(() => {
                    dispatch(customAlert(false, ""));
                  }, 1500);
                  // toast.warning('Please enter delivery date');
                } else {
                  dispatch(createFutureMessage(obj)).then((res) => {
                    setTitle("");
                    setFiles([]);
                    setSendTo("");
                    setMessage("");
                    setEmail("");
                    setSMS("");
                    setDeliveryDate("");
                    setDeliveryTime("");
                    toggleModal("addFuture");
                  });
                }
              }}
            >
              <div className="d-flex">
                <span
                  className="pointer ml-auto"
                  onClick={(e) => {
                    toggleModal("addFuture");
                    clearFields();
                  }}
                >
                  <i className="fa fa-times"></i>
                </span>
              </div>
              <div className="d-flex justify-content-center">
                <h4 className="font-weight-bold">Schedule a Future Message</h4>
              </div>
              <label className="d-flex mt-4">Title</label>
              <input
                className="form-control"
                placeholder="Title"
                type="text"
                required
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
              <div className="position-relative">
                <div {...getRootProps()} className="mt-5">
                  <input {...getInputProps()} />
                  <div
                    className="jumbotron ml-0 "
                    style={{
                      paddingLeft: 10,
                      marginBottom: 10,
                      borderStyle: "dashed",
                      borderRadius: 5,
                      borderWidth: 1,
                      borderColor: "black",
                      justifyContent: "center",
                      alignItems: "center",
                      textAlign: "center",
                      left: "50%",
                    }}
                  >
                    <i className="fas fa-cloud-upload-alt fa-5x " />
                    <p
                      style={{ cursor: "default" }}
                      className="text-black text-lg"
                    >
                      Drop file here
                    </p>
                  </div>
                </div>
                <Row
                  className="position-absolute"
                  style={{ top: "10px", left: "20px" }}
                >
                  {images}
                </Row>
              </div>
              <label className="d-flex mt-4">
                What message do you want to send?
              </label>
              <textarea
                className="form-control"
                rows={5}
                placeholder="Message"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              />
              <label className="d-flex mt-4">Send to</label>
              <input
                className="form-control"
                placeholder="Name"
                type="text"
                required
                value={sendTo}
                onChange={(e) => setSendTo(e.target.value)}
              />
              <Row>
                <Col md="6">
                  <label className="d-flex mt-4">Email</label>
                  <input
                    className="form-control"
                    placeholder="Email address"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </Col>
                <Col md="6">
                  <label className="d-flex mt-4">Phone No</label>
                  <PhoneInput
                    country={"us"}
                    inputStyle={{
                      height: "50px",
                    }}
                    buttonStyle={{
                      background: "white",
                      marginRight: "20px",
                    }}
                    value={sms}
                    onChange={(phone) => setSMS(phone)}
                  />
                </Col>
              </Row>
              <Row>
                <Col md="6">
                  <label className="d-flex mt-4">Delivery date</label>
                  <input
                    className="form-control"
                    type="date"
                    required
                    min={moment().toISOString().substring(0, 10)}
                    value={deliveryDate}
                    onChange={(e) => setDeliveryDate(e.target.value)}
                  />
                </Col>
                <Col md="6">
                  <label className="d-flex mt-4">Delivery Time</label>
                  <input
                    className="form-control"
                    type="time"
                    required
                    value={deliveryTime}
                    onChange={(e) => setDeliveryTime(e.target.value)}
                  />
                </Col>
              </Row>
              <div className="mt-5 d-flex align-items-center justify-content-center">
                <Button
                  className="btn-outline dashboard-btn"
                  type="submit"
                  disabled={loading}
                >
                  {loading ? <Spinner size="md" /> : "+ Add Future message"}
                </Button>
                <Button
                  className="ml-3 btn-outline dashboard-btn"
                  onClick={(e) => {
                    toggleModal("addFuture");
                    clearFields();
                  }}
                >
                  CANCEL
                </Button>
              </div>
            </Form>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
}

const Message = (props) => {
  let { future, dispatch, authUser, loading } = props;
  const [media, setMedia] = useState([]);
  const [future_id, setFutureId] = useState("");
  const [title, setTitle] = useState(future.title);
  const [message, setMessage] = useState(future.message);
  const [sendTo, setSendTo] = useState(future.send_to);
  const [email, setEmail] = useState(future.email);
  const [sms, setSMS] = useState(future.sms);
  const [deliveryDate, setDeliveryDate] = useState(future.deliveryDate);
  const [deliveryTime, setDeliveryTime] = useState(future.deliveryTime);
  const [files, setFiles] = useState([]);
  const [delModal, setDelModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const clearFields = () => {
    setTitle("");
    setMessage("");
    setSendTo("");
    setEmail("");
    setSMS("");
    setDeliveryDate("");
    setDeliveryTime("");
    setFiles([]);
  };
  const delToggle = () => {
    setDelModal(!delModal);
  };
  const editToggle = () => {
    setEditModal(!editModal);
  };
  const viewToggle = () => {
    setViewModal(!viewModal);
  };
  const { getRootProps, getInputProps, acceptedFiles } = useDropzone({
    accept: "image/*",
    onDrop: (acceptedFiles) => {
      let tempFiles = acceptedFiles.map((file) =>
        Object.assign(file, {
          preview: URL.createObjectURL(file),
        })
      );
      let tempArr = files.concat(tempFiles);
      setFiles(tempArr);
      // setFiles(
      // 	[
      // 		Object.assign(acceptedFiles[0], {
      // 			preview: URL.createObjectURL(acceptedFiles[0]),
      // 		}),
      // 	]
      // 	// acceptedFiles.map(file =>
      // 	// 	Object.assign(file, {
      // 	// 		preview: URL.createObjectURL(file),
      // 	// 	})
      // 	// )
      // );
    },
  });
  let images = files.map((file, index) => (
    <Row key={file.name}>
      <Col xs="4">
        <div style={{ position: "relative" }}>
          <i
            className="fas fa-minus-circle"
            style={{
              color: "red",
              position: "absolute",
              top: "0%",
              right: "0%",
              cursor: "pointer",
            }}
            onClick={() => {
              files.splice(index, 1);
              setFiles([...files]);
            }}
          ></i>
          {file.type.split("/")[0] == "image" ? (
            <img
              src={file.preview}
              style={{ width: "100px", height: "100px" }}
              alt="preview"
              className="mx-2 mt-2"
            ></img>
          ) : (
            <video
              src={file.preview}
              style={{ width: "100px", height: "100px" }}
              alt="preview"
              className="mx-2 mt-2"
            ></video>
          )}
          {/* <i onClick={remove(file)} style={{position:"absolute",top:"0%",left:"70%",cursor:"pointer"}} className='fas fa-times-circle' /> */}
        </div>
      </Col>
    </Row>
  ));
  return (
    <div className="message h-100 d-flex flex-column justify-content-between">
      {/* Delete Modal */}
      <Modal isOpen={delModal} centered toggle={delToggle}>
        <ModalBody>
          <div className="text-center">
            <i
              className="far fa-times-circle text-danger"
              style={{ fontSize: 70 }}
            ></i>
            <br />
            <br />
            <span className="mt-5" style={{ fontSize: 30 }}>
              Are you sure?
            </span>
            <br />
            <br />
            <span className="mt-5" style={{ fontSize: 16 }}>
              Do you really want to remove this message? This process cannot be
              undone.
            </span>
            <br />
            <br />
            <br />
            <Button color="secondary" onClick={delToggle}>
              Cancel
            </Button>{" "}
            <Button
              color="danger"
              onClick={async (e) => {
                e.preventDefault();
                dispatch(deleteFutureMessage(future_id, media));
                delToggle();
              }}
            >
              Delete
            </Button>
          </div>
        </ModalBody>
      </Modal>
      {/* Edit Modal */}
      <Modal
        isOpen={editModal}
        size="lg"
        centered
        className="custom-modal"
        // toggle={editToggle}
      >
        <ModalBody>
          <div className="modal-content-wrapper ">
            <Form
              onSubmit={(e) => {
                e.preventDefault();
                if (files.length > 0) {
                  let obj = {
                    title: title,
                    message: message,
                    send_to: sendTo,
                    email: email,
                    sms: sms,
                    deliveryDate: deliveryDate,
                    deliveryTime: deliveryTime,
                    media: files,
                    sender_id: authUser.id,
                  };
                  dispatch(updateFutureMessage(future.id, obj)).then(() => {
                    setFiles([]);
                    editToggle();
                    // clearFields();
                  });
                } else {
                  let obj = {
                    title: title,
                    message: message,
                    send_to: sendTo,
                    email: email,
                    sms: sms,
                    deliveryDate: deliveryDate,
                    deliveryTime: deliveryTime,
                    media: files,
                    sender_id: authUser.id,
                  };
                  dispatch(updateFutureMessage(future.id, obj)).then((res) => {
                    setFiles([]);
                    editToggle();
                  });
                }
              }}
            >
              <div className="d-flex">
                <span
                  className="pointer ml-auto"
                  onClick={() => {
                    editToggle();
                    clearFields();
                  }}
                >
                  <i className="fa fa-times"></i>
                </span>
              </div>
              <div className="d-flex justify-content-center">
                <h4 className="font-weight-bold">Update Future Message</h4>
              </div>
              <label className="d-flex mt-4">Title</label>
              <input
                className="form-control"
                placeholder="Title"
                type="text"
                required
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
              <div className="position-relative">
                <div {...getRootProps()} className="mt-5">
                  <input {...getInputProps()} />
                  <div
                    className="jumbotron ml-0 "
                    style={{
                      paddingLeft: 10,
                      marginBottom: 10,
                      borderStyle: "dashed",
                      borderRadius: 5,
                      borderWidth: 1,
                      borderColor: "black",
                      justifyContent: "center",
                      alignItems: "center",
                      textAlign: "center",
                      left: "50%",
                    }}
                  >
                    <i className="fas fa-cloud-upload-alt fa-5x " />
                    <p
                      style={{ cursor: "default" }}
                      className="text-black text-lg"
                    >
                      Drop file here
                    </p>
                  </div>
                </div>
                <Row
                  className="position-absolute"
                  style={{ top: "10px", left: "20px" }}
                >
                  {images}
                </Row>
              </div>
              {future.media_files && future.media_files.length > 0 && (
                <>
                  <Label className="mt-3">Previous Images</Label>
                  <Row>
                    {future.media_files &&
                      future.media_files.length > 0 &&
                      future.media_files.map((media, index) => {
                        return (
                          <Col xs="3">
                            <div
                              style={{
                                position: "relative",
                              }}
                            >
                              <i
                                className="fas fa-minus-circle"
                                style={{
                                  color: "red",
                                  position: "absolute",
                                  top: "0%",
                                  right: "0%",
                                  cursor: "pointer",
                                }}
                                onClick={(e) => {
                                  e.preventDefault();
                                  dispatch(
                                    deleteSingleMediaFile(future.id, media)
                                  );
                                }}
                              ></i>
                              <img
                                src={media}
                                style={{
                                  width: "100px",
                                  height: "100px",
                                }}
                                alt="preview"
                                className="mx-2 mt-2"
                              ></img>
                              {/* <i onClick={remove(file)} style={{position:"absolute",top:"0%",left:"70%",cursor:"pointer"}} className='fas fa-times-circle' /> */}
                            </div>
                          </Col>
                        );
                      })}
                  </Row>
                </>
              )}
              <label className="d-flex mt-4">
                What message do you want to send?
              </label>
              <textarea
                className="form-control"
                rows={5}
                placeholder="Message"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              />
              <label className="d-flex mt-4">Send to</label>
              <input
                className="form-control"
                placeholder="Name"
                type="text"
                required
                value={sendTo}
                onChange={(e) => setSendTo(e.target.value)}
              />
              <Row>
                <Col md="6">
                  <label className="d-flex mt-4">Email</label>
                  <input
                    className="form-control"
                    placeholder="Email address"
                    type="email"
                    readOnly
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </Col>
                <Col md="6">
                  <label className="d-flex mt-4">Phone No</label>
                  <PhoneInput
                    country={"us"}
                    inputStyle={{
                      height: "50px",
                    }}
                    disabled
                    buttonStyle={{
                      background: "white",
                      marginRight: "20px",
                    }}
                    value={sms}
                    onChange={(phone) => setSMS(phone)}
                  />
                  {/* <input
										className='form-control'
										placeholder='+44'
										type='tel'
										readOnly
										value={sms}
										onChange={e => setSMS(e.target.value)}
									/> */}
                </Col>
              </Row>
              <Row>
                <Col md="6">
                  <label className="d-flex mt-4">Delivery date</label>
                  <input
                    className="form-control"
                    type="date"
                    required
                    min={moment().toISOString().substring(0, 10)}
                    value={deliveryDate}
                    onChange={(e) => setDeliveryDate(e.target.value)}
                  />
                </Col>
                <Col md="6">
                  <label className="d-flex mt-4">Delivery Time</label>
                  <input
                    className="form-control"
                    type="time"
                    required
                    value={deliveryTime}
                    onChange={(e) => setDeliveryTime(e.target.value)}
                  />
                </Col>
              </Row>
              <div className="mt-5 d-flex align-items-center justify-content-center">
                <Button
                  className="btn-outline dashboard-btn"
                  type="submit"
                  disabled={loading}
                >
                  {loading ? <Spinner size="md" /> : "✎ Update Future message"}
                </Button>
                <Button
                  className="ml-3 btn-outline dashboard-btn"
                  onClick={() => {
                    editToggle();
                    clearFields();
                  }}
                >
                  CANCEL
                </Button>
              </div>
            </Form>
          </div>
        </ModalBody>
      </Modal>
      {/* View Modal */}
      <Modal isOpen={viewModal} toggle={viewToggle} centered>
        <div className="text-right pointer text-danger mr-2">
          <i className="fa fa-times" onClick={viewToggle}></i>
        </div>
        <ModalBody>{future.message}</ModalBody>
      </Modal>
      <div>
        <div className="message_image">
          {future.media_files && future.media_files.length > 0 ? (
            <img
              src={future.media_files.length > 0 && future.media_files[0]}
              alt="future message media"
            />
          ) : (
            <></>
          )}
        </div>

        <h4 className="font-weight-bold">to: {future.send_to}</h4>
        <p className="my-2 future-messages-height">
          {future.message.length > 100 ? (
            <>
              {future.message.slice(0, 100) + "..."}
              <small>
                <i
                  className="fa fa-eye ml-2 pointer text-success"
                  onClick={viewToggle}
                ></i>
              </small>
            </>
          ) : (
            future.message
          )}{" "}
        </p>
      </div>
      <div>
        <small className="font-weight-bold">Delivery date</small>
        <hr className="my-2" />
        <div className="d-flex align-items-center">
          <small>{future.deliveryDate}</small>
          <small className="ml-3">{future.deliveryTime}</small>
          <small className="ml-auto mr-3 text-muted">
            <i
              className="fa fa-pencil text-info pointer"
              onClick={editToggle}
            ></i>
          </small>
          <small className="text-muted">
            <i
              className="fa fa-trash pointer text-danger"
              onClick={(e) => {
                e.preventDefault();
                setFutureId(future.id);
                setMedia(future.media_files);
                delToggle();
              }}
            ></i>
          </small>
        </div>
      </div>
    </div>
  );
};

export default FutureMessages;
